<ng-container [formGroup]="form">
  <mat-form-field>
    <mat-label>Date of Service</mat-label>
    <input
      formControlName="{{ controlName }}"
      matInput
      [matDatepicker]="dateOfServicePicker"
      data-testid="dateOfService"
      [min]="dateOfServiceMinMax.min"
      [max]="dateOfServiceMinMax.max"
    />
    <mat-datepicker-toggle matSuffix [for]="dateOfServicePicker"></mat-datepicker-toggle>
    <mat-datepicker #dateOfServicePicker></mat-datepicker>
    <mat-error *ngIf="hasError()">
      {{ getError() }}
    </mat-error>
  </mat-form-field>
</ng-container>
